import React from 'react';

import { ReactComponent as Arrow } from '../../../../images/icons/fs-lc-arrow.svg';
import SmartLink from '../../../Common/SmartLink';

export default function ListItem({ item, styles, isTitle = false, isCta = false }) {
  return (
    <li className={isTitle ? styles.columnHeader : ''} key={item.title}>
      {item.url ? (
        <SmartLink to={item.url} data-analytics-component={'nav-menu-link'} data-analytics-id={item.title}>
          {item.label && <div className={styles.label}>{item.label}</div>}
          <span
            style={{ fontWeight: isCta ? '700' : '500' }}
            className={[isTitle ? styles.columnTitle : '', item.colorTheme ? styles[item.colorTheme] : ''].join(' ')}
          >
            {item.title}
            {isTitle && <Arrow />}
          </span>
        </SmartLink>
      ) : (
        <>
          {item.label && <div className={styles.label}>{item.label}</div>}
          <span
            className={[isTitle ? styles.columnTitle : '', item.colorTheme ? styles[item.colorTheme] : ''].join(' ')}
          >
            {item.title}
          </span>
        </>
      )}
    </li>
  );
}
